import React from 'react';

import { Layout, Modal, Breadcrumb, Select } from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import TablaMostrarRendiciones from './TablaMostrarRendiciones';

import getRendicionPorOrganismo from '../../../graphql/querys/ventas/getRendicionPorOrganismo.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';

import VerReportesRendicion from './VerReportesRendicion';

@compose(
  graphql(getUsuario, {
    name: 'usuario',
  }),
  graphql(getOrganismos)
)
class ListarReportesRendicion extends React.Component {
  state = {
    tipo_sellos: [],
    llamada: false,
    fechaInicio: '',
    fechaFin: '',
    idOrganismo: '',
    step: 0,
    listar: true,
  };

  onSubmit = e => {
    e.preventDefault();
    // console.log(e);
    this.buscar();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.usuario && !this.state.llamada) {
      this.cambiarOrganismo(nextProps.usuario.getUsuario.organismo._id);
    }
  }

  cambiarOrganismo = idOrganismo => {
    this.setState(
      {
        ...this.state,
        idOrganismo: idOrganismo,
      },
      () => {
        this.props.client
          .query({
            query: getRendicionPorOrganismo,
            variables: { idOrganismo: idOrganismo },
            fetchPolicy: 'network-only',
          })
          .then(res => {
            const rendiciones = res.data.getRendicionPorOrganismo;
            console.log('Respuesta exitosa!');
            console.log(rendiciones);

            if (rendiciones) {
              this.setState({
                ...this.state,
                llamada: true,
                rendiciones: rendiciones,
              });
            }
          })
          .catch(err => {
            console.log('Error en la busqueda de Rendicion');
            console.log(err);

            Modal.error({
              title: 'Error a la hora de buscar la rendicion en la BD',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.data.getOrganismos, { _id: idOrganismo });
    organismo ? (nombre = organismo.nombre) : (nombre = '');
    return nombre;
  };

  verRendicion = _id => {
    let registro = _.find(this.state.rendiciones, { _id: _id });
    this.setState({
      ...this.state,
      listar: false,
      registro: registro,
    });
  };

  atras = () => {
    this.setState({
      ...this.state,
      listar: true,
      registro: {},
    });
  };

  render() {
    const { data } = this.props;
    if (data.loading) {
      return <Loading />;
    }

    let usuario = this.props.usuario;

    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');

    // console.log('PROPS EN VER STOCK');
    // console.log(this.props);

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Administracion General</Breadcrumb.Item>
          <Breadcrumb.Item>Rendiciones</Breadcrumb.Item>
          <Breadcrumb.Item>Consultar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          {this.state.listar && (
            <div>
              <h1 style={{ textAlign: 'center', marginTop: 15 }}>
                Administración General
              </h1>
              <h2 style={{ textAlign: 'center', marginTop: 40 }}>
                Reportes de Rendicion
              </h2>
              <h3 style={{ textAlign: 'center', marginTop: 20 }}>
                ORGANISMO:
                <Select
                  style={{ width: 500, marginLeft: 10 }}
                  id="organismos"
                  placeholder="Seleccione el organismo"
                  defaultValue={usuario.getUsuario.organismo._id}
                  disabled={
                    usuario.getUsuario.organismo._id != '00004' &&
                    usuario.getUsuario.rol != 'SUPERVISOR'
                  }
                  onSelect={valor => this.cambiarOrganismo(valor)}
                >
                  {this.props.data.getOrganismos &&
                    this.props.data.getOrganismos.map(organismo => (
                      <Select.Option key={organismo._id}>
                        {organismo.nombre}
                      </Select.Option>
                    ))}
                </Select>
              </h3>

              <h5 style={{ textAlign: 'center', marginTop: 20 }}>
                FECHA DE GENERACION: {fGeneracion}
              </h5>

              <TablaMostrarRendiciones
                data={this.state.rendiciones}
                organismo={this.state.idOrganismo}
                verRendicion={this.verRendicion}
              />
            </div>
          )}
          {!this.state.listar && (
            <VerReportesRendicion
              fechaInicio={this.state.registro.fechaInicio}
              fechaFin={this.state.registro.fechaFin}
              ventasEfectivo={this.state.registro.ventasEfectivo}
              ventasPosnet={this.state.registro.ventasPosnet}
              ingresos={this.state.registro.ingresos}
              depositos={this.state.registro.depositos}
              nombreOrganismo={this.state.registro.organismo.nombre}
              fechaGeneracion={this.state.registro.fechaGeneracion}
              atras={this.atras}
            />
          )}
        </Layout>
      </div>
    );
  }
}

export default withApollo(ListarReportesRendicion);
